import React from 'react'
import { TouchableOpacity, Text } from 'react-native';
import { Link, Switch, Route, useRouteMatch } from './routing';

const Lesson1 = () => {
  let match = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${match.path}/`}>
        <Text>Izvolite</Text>
        <Text>Dobar dan, ja ću oko sto grama sira Edama</Text>
        <Link to={`${match.path}/1`}><Text>Next page</Text></Link>
      </Route>
      <Route exact path={`${match.path}/1`}>
        <Text>Koje hoćete?</Text>
        <Text>Ovaj ovde</Text>
        <Link to={`${match.path}/2`}><Text>Next page</Text></Link>
      </Route>
      <Route exact path={`${match.path}/2`}>
        <Text>Važi, hoćete li rezano ili komad?</Text>
        <Text>Samo komad, molim vas</Text>
        <Link to={`${match.path}/3`}><Text>Next page</Text></Link>
      </Route>
      <Route exact path={`${match.path}/3`}>
        <Text>Još nešto?</Text>
        <Text>Ne, to je sve</Text>
        <Link to={`${match.path}/4`}><Text>Next page</Text></Link>
      </Route>
      <Route exact path={`${match.path}/4`}>
        <Text>Izvolite, prijatno</Text>
        <Text>Hvala, zdravo!</Text>
        <Link to='/index'><Text>Done</Text></Link>
      </Route>
    </Switch>
  )
}
export default Lesson1
